import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { objectToCamel, objectToSnake } from 'ts-case-convert';
import {
  IIdentityProviderDetail,
  IIdentityProviderSavePayload,
  IIdentityProviderSummary,
  IListQuery,
  IPageResponse,
  IPaginatedList,
} from 'src/app/models';
import { UtilsService } from '../utils/utils.service';
import { IdentityProviderHttpService } from './identity-provider.http.service';

@Injectable({
  providedIn: 'root',
})
export class IdentityProviderService {
  constructor(
    private identityProviderHttpService: IdentityProviderHttpService,
    private utilsService: UtilsService,
  ) {}

  async searchIdentityProviders(query: IListQuery): Promise<IPaginatedList<IIdentityProviderSummary>> {
    const queryParams = this.utilsService.toQueryParams(query);
    const response = await lastValueFrom(this.identityProviderHttpService.searchIdentityProviders(queryParams));
    const identityProviders = objectToCamel(response as object) as { data: IPageResponse<IIdentityProviderSummary> };
    return this.utilsService.getDataWithPagination(identityProviders.data, query.page);
  }

  async getIdentityProvider(identityProviderId: number): Promise<IIdentityProviderDetail> {
    const response = await lastValueFrom(this.identityProviderHttpService.getIdentityProvider(identityProviderId));
    return objectToCamel(response as object) as IIdentityProviderDetail;
  }

  async saveIdentityProvider(
    identityProvider: IIdentityProviderSavePayload,
    identityProviderId?: number,
  ): Promise<IIdentityProviderDetail> {
    const body = objectToSnake(identityProvider);
    const source$ = identityProviderId
      ? this.identityProviderHttpService.updateIdentityProvider(identityProviderId, body)
      : this.identityProviderHttpService.createIdentityProvider(body);
    const response = await lastValueFrom(source$);
    return objectToCamel(response as object) as IIdentityProviderDetail;
  }

  async deleteIdentityProvider(identityProviderId: number) {
    await lastValueFrom(this.identityProviderHttpService.deleteIdentityProvider(identityProviderId));
  }
}
